var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrosoft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0305 10.0169L9.3703 10.3892L9.74256 21.0493L20.4027 20.6771L20.0305 10.0169Z",
    fill: "#F24E23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4902 9.61675L20.83 9.98901L21.2023 20.6492L31.8624 20.2769L31.4902 9.61675Z",
    fill: "#81B900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4307 21.4766L9.77051 21.8489L10.1428 32.509L20.8029 32.1368L20.4307 21.4766Z",
    fill: "#13A6F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8903 21.0762L21.2302 21.4485L21.6024 32.1087L32.2626 31.7364L31.8903 21.0762Z",
    fill: "#FEB700"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.6ab9c1504f48d276c41e9e25f18da556.svg";
export { ForwardRef as ReactComponent };